import { CompetitorComparison } from '@/components/CompetitorComparison';
import { useSEO } from '@/hooks/useSEO';

export default function SalesLayerComparison() {
  useSEO({
    title: 'Ommni vs Sales Layer - PIM Comparison',
    description: 'Compare Ommni and Sales Layer. Ommni includes inventory + fulfillment logic, workflow automation, and flexible pricing vs Sales Layer\'s catalog-focused solution.',
    keywords: 'ommni vs sales layer, sales layer alternative, PIM comparison, product catalog management',
    canonical: 'https://ommni.io/competitors/sales-layer',
  });

  return (
    <CompetitorComparison
      title="Ommni vs Sales Layer"
      competitorName="Sales Layer"
      competitorUrl="https://www.saleslayer.com/"
      whyOmmni={[
        "Inventory + Fulfillment Logic: Ommni combines powerful <a href='/features/pim'>product management</a> with real-time <a href='/features/inventory'>inventory</a> rules, thresholds, and location-based availability.",
        "Low-Code Workflow Engine: Ommni lets you build enrichment flows, business rules, and data transformation pipelines with <a href='/features/ommni-flow'>OmmniFlow</a> without developer help.",
        "Better for Retailers: Ommni is designed for brands and retailers trading across multiple systems — Sales Layer is more focused on supplier catalog management.",
        "Scalable & Global: Ommni supports multi-currency, multi-region setups and integrates easily with ERP, eComm, <a href='/features/dom'>OMS</a>, and POS platforms."
      ]}
      comparisonTable={[
        { feature: "Inventory Logic", ommni: true, competitor: false, link: "/features/inventory" },
        { feature: "Fulfillment Integrations", ommni: true, competitor: false, link: "/features/dom" },
        { feature: "Retailer-Focused", ommni: true, competitor: false },
        { feature: "Workflow & Rules Engine", ommni: true, competitor: false, link: "/features/ommni-flow" },
        { feature: "Global Readiness", ommni: true, competitor: true }
      ]}
    />
  );
}
